import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import "../../styles/main.scss"
import "./index.scss"
import EAFormEmbed from "../EAFormEmbed"

export default function FormCTABanner({ component }) {
  const {
    image,
    headline,
    formLink,
    description,
    formHeadline,
    donationForm,
    amountButtons,
    leftBackground,
    rightBackground,
    recurringDonationOptions,
  } = component;
  
  const leftBg = leftBackground[0]
  const rightBg = rightBackground[0]

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [frequency, setFrequency] = useState("One time")

  const mouseEnter = () => {
    setDropdownOpen(true)
  }

  const mouseLeave = () => {
    setDropdownOpen(false)
  }

  const clickFreq = e => {
    setFrequency(e.target.getAttribute("data-value"))
  }

  return (
    <div
      className="form-cta-banner"
      style={{
        backgroundColor: leftBg.hasImage ? "" : leftBg.backgroundColor,
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <h2 className="text-white oblique">{headline}</h2>
            {description && (
              <p className="text-white description">{description}</p>
            )}
          </div>
          <div className="col-lg-5">
            {donationForm ? (
              <div className="donationButtons container">
                <h4 className="oblique text-white">{formHeadline}</h4>
                <div className="row btnRow">
                  {amountButtons?.map(amount => (
                    <a
                      href={`${formLink}?am=${amount.amount}${
                        frequency !== "One time" && "&r=true"
                      }`}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary"
                      key={amount.amount}
                    >
                      ${amount.amount}
                    </a>
                  ))}
                  <a
                    href={formLink}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-primary otherBtn"
                  >
                    Other
                  </a>
                </div>
                {recurringDonationOptions && (
                  <div className="row align-items-center">
                    <div className="col-md-5">
                      <p className="text-white">Make this contribution</p>
                    </div>
                    <div
                      className="dropdown col-md-5"
                      onMouseEnter={mouseEnter}
                      onMouseLeave={mouseLeave}
                    >
                      {frequency}
                      <ul
                        className={`dropdown-menu ${
                          dropdownOpen ? "open" : null
                        }`}
                      >
                        {recurringDonationOptions?.map(option => (
                          <li
                            className="dropdown-item"
                            data-value={option.recurringDonation}
                            id={`donation-${option.recurringDonation}`}
                            key={option.recurringDonation}
                            onClick={e => clickFreq(e)}
                          >
                            {option.recurringDonation}
                          </li>
                        ))}
                        <li
                          className="dropdown-item"
                          id="donation-onetime"
                          onClick={e => clickFreq(e)}
                          data-value="One time"
                        >
                          One time
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <EAFormEmbed formLink={formLink} />
            )}
          </div>
        </div>
      </div>
      {rightBg.hasBackgroundImage && (
        <GatsbyImage
          image={getImage(rightBg.image)}
          className="form-cta-banner__right-img"
          alt=""
        />
      )}
      {rightBg.hasBackgroundImage === false && (
        <div
          className="form-cta-banner__right-bg"
          style={{ background: rightBg.backgroundColor }}
        ></div>
      )}
      <GatsbyImage
        image={getImage(image)}
        className="form-cta-banner__main-img"
        alt=""
      />
    </div>
  )
}
